import { useMemo } from 'react';
import type { FreePhoto_Base } from '~/common/typescript/models/FreePhoto';
import { parseMetadata, type FreePhotoMetadata } from '../utils/freePhotoUtils';

/**
 * Custom hook to parse and access FreePhoto metadata
 * @param photo - FreePhoto object
 * @returns Parsed metadata or null
 */
export const useFreePhotoMetadata = (photo: FreePhoto_Base | null): FreePhotoMetadata | null => {
  return useMemo(() => {
    if (!photo || !photo.metadata) return null;
    const parsed = parseMetadata(photo.metadata);
    console.log('[FreePhoto] raw metadata string:', photo.metadata);
    console.log('[FreePhoto] parsed metadata:', parsed);
    return parsed;
  }, [photo]);
};